<template>
  <div>
    <div class="dashboard-title">{{ $t("dashboard.withdraw.title") }}</div>
    <hr />
    <div class="recharge-steps" v-if="step == 1">
      <div class="stripe-logo">
        <img src="../../assets/Stripe_Logo.png" alt="Stripe Logo" />
      </div>
      <div class="login-form">
        <p>{{ $t("dashboard.withdraw.enterAmount") }}</p>
        <div class="alert alert-danger w-100 py-1" role="alert" v-if="showErr">
          {{ err }}
        </div>
        <div class="cash-out-amount">
            <input required type="number" id="amount" v-model="amount" />
            <label for="amount">USD</label>
        </div>
        <span
          >{{ $t("dashboard.withdraw.current")
          }}${{ numberWithCommas(balance) }}</span
        >
        <div class="btn btn-gold btn-block text-white" @click="cashOut">
          {{ $t("dashboard.withdraw.cashout") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      step: 1,
      amount: null,
      balance: "",
      showErr: false,
      err: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 调用API获取余额数据
      this.balance = 125631;
    },
    cashOut() {
      if (!this.amount) {
        this.err = this.$t("dashboard.withdraw.err");
        this.showErr = true;
        return;
      }
      alert(this.amount)
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    amount: function () {
      if (this.amount) this.showErr = false;
    },
  },
};
</script>

<style scoped>
.recharge-steps {
  .login-form {
    box-shadow: 0px 4.4px 22px 0px #0000000d;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding: 2rem;
    width: 100%;
    max-width: 436px;
    margin: 1rem auto;
    p {
      text-align: center;
      width: 100%;
      color: #3b3e51;
      font-size: 1rem;
      font-weight: 400;
      margin: 0;
    }
    .btn-block {
      width: 100%;
      font-size: 1.5rem;
      font-weight: 700;
    }
    span {
      color: #808695;
      font-size: 0.85rem;
    }
    .cash-out-amount {
        position: relative;
        width: 100%;
        input {
            background-color: white;
            border: 1.1px solid #F2F3F4;
            border-radius: 1rem;
            height: 62px;
            padding-left: 4.5rem;
            width: 100%;
        }
        label {
            position: absolute;
            color: #3B3E51;
            font-size: 1rem;
            line-height: 1rem;
            top: 31px;
            margin-top: -0.5rem;
            left: 2rem;
        }
    }
  }
}
</style>
